<template>
  <div>
    <PageContainer />
  </div>
</template>
<script>
import PageContainer from './components/container'
export default {
  name: 'customerManage-myCust',
  components: { PageContainer },
}
</script>
